import React from "react";

const Checkbox = ({ label, checked, onChange }) => {
  return (
    <div className="flex items-center space-x-3">
      <input
        type="checkbox"
        className="form-checkbox h-5 w-5 text-blue-600 transition duration-150 ease-in-out"
        checked={checked}
        onChange={onChange}
      />
      {label && <label className="text-gray-700">{label}</label>}
    </div>
  );
};

export default Checkbox;
